import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const PromotionPageStyle = {
  self: css`
    /*  */
  `,
  wrapper: (isEvent: boolean) => css`
    min-height: var(--min-height-content-layout);
    padding: ${isEvent ? "20px 0" : "20px"};
    ${media.sm} {
      padding: 12px 0px;
    }
  `,
  head: css`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 26px;
  `,
  headerEvent: css`
    display: flex;
    flex-direction: column;
    .title {
      background-color: ${theme.colors.orange[200]};
      border-radius: 3px 3px 0px 0px;
      border-bottom: 1px solid #ddd;
      text-align: center;

      padding-top: 9px;
      padding-bottom: 12px;

      span {
        font-size: 21px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px;

        color: ${theme.colors.white};
      }
    }
  `,
  listPromos: css`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    ${media.sm} {
      grid-template-columns: 1fr;
      gap: 6px;
    }
  `,

  empty: css`
    display: flex;
    justify-content: center;
    width: 100%;
    height: 500px;
  `,

  categoryWrapper: css`
    margin-bottom: 20px;
  `,

  banner: css`
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
      border-bottom: solid 20px ${theme.colors.orange[200]};
    }
  `,
};
